<template>
  <div>
    <modal
      v-model="showModal"
      :title="title"
      :backdrop="allowModalToBeClosed"
      :append-to-body="true"
      :class="customClasses"
      @hide="close"
    >
      <slot>
        <p v-t="'CONFIRM_MESSAGE'" />
      </slot>

      <div
        v-if="!showHeaderCloseButton"
        slot="header"
      >
        <h4
          v-t="title"
          class="modal-title"
        />
      </div>

      <div slot="footer">
        <btn
          v-if="showCustomButton"
          type="primary"
          :disabled="confirmButtonDisabled || showConfirmButtonLoading"
          @click="customAction"
        >
          {{ confirmCustomActionText }}
          <Loader
            v-if="showConfirmButtonLoading"
            custom-class="size-sm"
          />
        </btn>

        <btn
          v-if="showConfirmButton"
          type="primary"
          :disabled="confirmButtonDisabled || showConfirmButtonLoading"
          @click="confirm"
        >
          {{ confirmActionText }}
          <Loader
            v-if="showConfirmButtonLoading"
            custom-class="size-sm"
          />
        </btn>

        <btn
          v-if="showCancelButton"
          v-t="'CANCEL'"
          :disabled="cancelButtonDisabled || isConfirmLoading"
          type="danger"
          @click="close"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import i18n from '@/i18n';
import sharedMessages from '@/core/locales';
import messages from './locales';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ConfirmationModal',
  emits: ['confirm', 'close', 'custom-action'],
  props: {
    entity: {
      type: Object,
      default() {
        return {
          id: '',
          name: ''
        };
      }
    },
    title: {
      type: String,
      default: i18n.t('CONFIRM')
    },
    confirmButtonLoading: {
      type: Boolean,
      default: false
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false
    },
    cancelButtonDisabled: {
      type: Boolean,
      default: false
    },
    confirmActionText: {
      type: String,
      default: i18n.t('YES')
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    showHeaderCloseButton: {
      type: Boolean,
      default: true
    },
    showCustomButton: {
      type: Boolean,
      default: false
    },
    confirmCustomActionText: {
      type: String,
      default: ''
    },
    allowModalToBeClosed: {
      type: Boolean,
      default: true
    },
    customClasses: {
      type: String,
      default: ''
    },
    onConfirm: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {
      showModal: true,
      isConfirmLoading: false,
    };
  },
  computed: {
    showConfirmButtonLoading() {
      return this.confirmButtonLoading || this.isConfirmLoading;
    },
  },
  methods: {
    confirm() {
      const result = this.onConfirm?.();
      this.$emit('confirm', this.entity);

      if (result instanceof Promise) {
        this.isConfirmLoading = true;
        result.finally(() => {
          this.isConfirmLoading = false;
        });
      }
    },
    close() {
      this.$emit('close');

      if (this.allowModalToBeClosed){
        this.showModal = false;
      }
    },
    customAction() {
      this.$emit('custom-action');
    }
  },
  i18n: {
    locale: 'en',
    sharedMessages,
    messages
  }
});
</script>

<style lang="scss" scoped>

</style>
